module.exports = __webpack_public_path__ + "static/media/aventura.d697a235.PNG";